export interface JsonContractAdvertiser {
  numClient?: number;
  name?: string;
  idGroupeAnnonceur?: number;
}

export class ContractAdvertiser {
  id: number;
  name: string;
  advertiserId: number;

  constructor(jsonContractAdvertiser: JsonContractAdvertiser = null) {
    this.id = jsonContractAdvertiser.numClient;
    this.name = jsonContractAdvertiser.name;
    this.advertiserId = jsonContractAdvertiser.idGroupeAnnonceur;
  }
}
